module.exports = __webpack_public_path__ + "img/circleArrow_03.5aee7662.png";